exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".maintenance-buttons[data-v-98296492] {\n  display: flex;\n}\n.maintenance-buttons .maintenance-button[data-v-98296492] {\n  width: 50%;\n}", ""]);

// exports
